/**
 * Whether a shareholder's document is a campaign's signed vote document.
 *
 * A voting-campaign-v1 campaign's signed documents carry its campaign_id (the vote page sends it to
 * upload-to-your-docs), so they match by id: a campaign named "2027 Proxy" no longer counts a signed
 * "2027 Proxy Amendment". Other campaigns, and documents signed before the id was added, keep the
 * name rules the vote page and dashboard have always used.
 *
 * @param {object} d - a document from userData.clients[client].documents
 * @param {object} o
 * @param {string} [o.campaignId] - activeCampaign.campaign_id (workflow campaigns only)
 * @param {string} o.docName - campaignDocuments[0]
 * @param {string} [o.cls] - a share class, when checking one class
 * @param {boolean} [o.multiDoc] - one document per class ("<name> (<class>)")
 * @param {boolean} [o.prefix] - legacy single check uses startsWith instead of includes
 */
export function isSignedCampaignDoc(d, { campaignId = null, docName = '', cls = null, multiDoc = false, prefix = false } = {}) {
	if (!d) return false;
	const name = String(d.name || '');
	if (campaignId && d.campaign_id) {
		if (d.campaign_id !== campaignId) return false;
		return !multiDoc || !cls || d.tag === cls || name.includes(`(${cls})`);
	}
	if (!docName) return false;
	if (multiDoc && cls) return name.includes(`${docName} (${cls})`);
	return prefix ? name.startsWith(docName) : name.includes(docName);
}
